import React from "react";
import videoFile from './assets/IMG_6471.MP4';

const Speeach = () => {
  return (
    <div
      className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12"
      style={{ background: "#123a2f" }}
    >
      <div className="flex flex-col lg:flex-row items-center lg:items-start gap-8 lg:gap-16">
        
        {/* Video Section */}
        <div className="w-full lg:w-1/2">
          <video
            width="100%"
            height="auto"
            controls
            className="rounded-lg"
          >
            <source src={videoFile} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>

        {/* Text Section */}
        <div className="w-full lg:w-1/2">
          <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-6">
            A Moment of Honor and Recognition
          </h1>

          <div className="text-white space-y-4 text-sm sm:text-base leading-relaxed">
            <p>
              Econirmit had the esteemed opportunity to showcase its sacred and sustainable offerings at an exclusive expo during the visit of Hon’ble President of India, Smt. Droupadi Murmu, to Ujjain. Our initiative of transforming temple flowers—especially from Mahakaleshwar Jyotirling—into eco-friendly products was warmly appreciated by the President herself. The Chief Minister of Madhya Pradesh also acknowledged Econirmit in his speech, praising the brand’s unique blend of spirituality, sustainability, and social impact.
            </p>
            <p>
              All our products are handcrafted by women flowercyclers, providing them with predictable and healthy livelihoods. We are building a new circular economy, converting waste that was unimagined before. Today, even orthodox temple authorities want to be part of our mission.
            </p>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Speeach;
